"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var undoActions = require("owa-mail-undo");
var datapoints_1 = require("./datapoints");
var getDeleteAllConfirmText_1 = require("./helpers/getDeleteAllConfirmText");
var getItemIdsFromConversations_1 = require("owa-mail-list-store/lib/utils/getItemIdsFromConversations");
var isFolderUnderDeletedFolder_1 = require("owa-mail-store/lib/utils/isFolderUnderDeletedFolder");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var emptyFolderService_1 = require("../services/emptyFolderService");
var owa_strings_1 = require("owa-strings");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_service_error_1 = require("owa-service-error");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_bulk_action_store_1 = require("owa-bulk-action-store");
var owa_analytics_1 = require("owa-analytics");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
/**
 * Get the type of items to delete based on view filter
 * @param viewFilter the view filter
 * @returns the text which indicates type of items to delete based on the view filter
 */
function getItemsTypeText(viewFilter) {
    switch (viewFilter) {
        case 'Unread':
            return owa_mail_strings_1.default.allUnreadItems;
        case 'Flagged':
            return owa_mail_strings_1.default.allFlaggedItems;
        case 'ToOrCcMe':
            return owa_mail_strings_1.default.allToMeItems;
        case 'All':
        default:
            return owa_mail_strings_1.default.allItems;
    }
}
/**
 * Get the folder scope text
 * @param focusedViewFilter the focused view filter
 * @param folderDisplayName the folder display name
 * @returns the folder scope text, e.g Focused Inbox, Other Inbox, Sent Items, etc.
 */
function getFolderScopeText(focusedViewFilter, folderDisplayName) {
    var focusedViewFilterText = '';
    switch (focusedViewFilter) {
        case 0 /* Focused */:
            focusedViewFilterText = owa_mail_strings_1.default.focusedViewFilterText + ' ';
            break;
        case 1 /* Other */:
            focusedViewFilterText = owa_mail_strings_1.default.otherViewFilterText + ' ';
            break;
    }
    return focusedViewFilterText + folderDisplayName;
}
/**
 * Empty folder without the confirm dialog
 * @param folder the folder to be emptied
 * @param disposalType the disposalType
 * @param clientLastSyncTime client last sync time used as a watermark
 * @param rowKeysToExclude item ids to exclude from empty folder operation
 */
var emptyFolderWithoutConfirmation = legacy_1.action('emptyFolderWithoutConfirmation')(function emptyFolderWithoutConfirmation(folder, disposalType, deleteSubFolders, clientLastSyncTime, rowKeysToExclude, tableViewId) {
    var itemIdsToExclude = rowKeysToExclude
        ? getItemIdsFromConversations_1.default(rowKeysToExclude, tableViewId)
        : [];
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError('emptyFolderWithoutConfirmation', owa_strings_1.format(owa_mail_strings_1.default.errorEmptyingFolder, folder.DisplayName), function () {
        return emptyFolderService_1.emptyFolderService(folder, disposalType, deleteSubFolders, clientLastSyncTime, itemIdsToExclude);
    }, undefined, function () {
        owa_bulk_action_store_1.lazyOnBulkActionFailure.importAndExecute(folder.FolderId.Id, owa_strings_1.format(owa_mail_strings_1.default.errorEmptyingFolder, folder.DisplayName));
    });
    stitch_1.raiseAction(actionTypes_1.actionNames.EmptyFolderStoreUpdate)(folder, clientLastSyncTime, rowKeysToExclude);
    return actionResponse;
});
var emptyFolderActionName = 'emptyFolderAction';
exports.emptyFolderActionName = emptyFolderActionName;
/**
 * Delete all conversations or items in the specified folder
 * @param folder the folder to be emptied
 * @param focusedViewFilter the focused view filter
 * @param viewFilter the view filter
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param clientLastSyncTime client last sync time used as a watermark
 * @param rowKeysToExclude row keyss to exclude from empty folder operation
 */
exports.default = legacy_1.action(emptyFolderActionName)(function emptyFolder(folder, focusedViewFilter, viewFilter, isExplicitSoftDelete, actionSource, rowKeysToExclude, clientLastSyncTime, tableViewId) {
    var _this = this;
    var confirmEmptyFolderSubtext;
    var disposalType;
    var deleteSubFolders;
    undoActions.clearLastUndoableAction();
    var folderScopeText = getFolderScopeText(focusedViewFilter, folder.DisplayName);
    var itemsTypeText = getItemsTypeText(viewFilter);
    var exclusionListCount = rowKeysToExclude ? rowKeysToExclude.length : 0;
    if (folder.distinguishedFolderId == 'deleteditems' ||
        folder.distinguishedFolderId == 'junkemail') {
        confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmPermanentEmptyFolderSubText, itemsTypeText, folderScopeText);
        deleteSubFolders = !owa_controls_feature_flags_1.isControlFeatureEnabled('doc-consumerUrl');
        // This is to ensure the contract on server that clientLastSyncTime and deleteSubFolders cannot be present at the same time
        clientLastSyncTime = deleteSubFolders ? null : clientLastSyncTime;
        disposalType = 'SoftDelete';
    }
    else if (isFolderUnderDeletedFolder_1.default(folder)) {
        confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderForFolderUnderDeletedItemsSubText, itemsTypeText, folderScopeText);
        deleteSubFolders = false;
        disposalType = 'SoftDelete';
    }
    else {
        if (isExplicitSoftDelete) {
            confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmPermanentEmptyFolderSubText, itemsTypeText, folder.DisplayName);
            disposalType = 'SoftDelete';
        }
        else {
            confirmEmptyFolderSubtext = owa_strings_1.format(owa_mail_strings_1.default.confirmEmptyFolderSubText, itemsTypeText, folderScopeText);
            disposalType = 'MoveToDeletedItems';
        }
        deleteSubFolders = false;
    }
    return owa_confirm_dialog_1.confirm(getDeleteAllConfirmText_1.default(actionSource, owa_mail_list_store_1.getListViewTypeForFolder(folder.FolderId.Id) /* listViewType */, folder.TotalCount - exclusionListCount, folder), confirmEmptyFolderSubtext, false /* resolveImmediately */, {
        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
        okText: owa_mail_strings_1.default.confirmEmptyFolderText,
    }).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                owa_analytics_1.logUsage(datapoints_1.default.emptyFolderDatapoint.datapoint.name, [
                    actionSource,
                    folder.TotalCount,
                    disposalType,
                ]);
                return [2 /*return*/, emptyFolderWithoutConfirmation(folder, disposalType, deleteSubFolders, clientLastSyncTime, rowKeysToExclude, tableViewId)];
            }
            return [2 /*return*/];
        });
    }); });
});
//# sourceMappingURL=emptyFolder.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/emptyFolder.js
// module id = 3835
// module chunks = 62